import {useEffect, useState} from 'react'
import {IPublicJobModel} from '../../hr/job/JobModel'
import {getPublicCompanyById, getPublicJob} from '../PublicApi'
import {IPublicCompanyModel} from '../PublicModels'

export type PublicJobState = 'loading' | 'loaded' | 'notFound'

/**
 * Yayındaki ilanı ve firmasının kariyer sayfası bilgisini yükler.
 * Firma pasife alınmışsa ilan da bulunamadı sayılır.
 */
export function usePublicJob(jobId: string) {
  const [job, setJob] = useState<IPublicJobModel | null>(null)
  const [company, setCompany] = useState<IPublicCompanyModel | null>(null)
  const [state, setState] = useState<PublicJobState>('loading')

  useEffect(() => {
    setState('loading')
    getPublicJob(jobId)
      .then(async ({data}) => {
        const companyResponse = await getPublicCompanyById(data.payload.corporateId)
        setJob(data.payload)
        setCompany(companyResponse.data.payload)
        document.title = `${data.payload.title} · ${companyResponse.data.payload.name}`
        setState('loaded')
      })
      .catch(() => setState('notFound'))
  }, [jobId])

  return {job, company, state}
}
